export default {
    inheritAttrs: false,

    props: {
        id: {
            type: String,
            default: '',
        },

        // used for Sitecore item naming. Items at the same level have to have unique names.
        name: {
            type: String,
            default: '',
        },

        // used for Sitecore field mapping. Atoms are specific, organisms are generic
        elementType: {
            type: String,
            default: '',
        },

        // Pointers are managed by the parent, element should not change self
        // Used to govern order and uniqueness of duplicate elements in Sitecore data
        pointer: {
            type: Number,
            default: -1,
        },

        // Sitecore datasource template ID
        templateId: {
            type: String,
            default: '',
        },

        // overrides element classes and binds it to data to be modified/saved
        classes: {
            type: String,
            default: '',
        },

        // set to true to change the root element to an anchor, and to add link-related options
        isLink: {
            type: Boolean,
            default: false,
        },

        // addtional properties for specific organism cases
        customAttributes: {
            type: Object,
            default: () => ({}),
        },

        htmlCustomAttributes: {
            type: Object,
            default: () => ({}),
        },

        // Link props start
        anchor: {
            type: String,
            default: '',
        },

        href: {
            type: String,
            default: '',
        },

        linkType: {
            type: String,
            default: 'internal',
        },

        mediaId: {
            type: String,
            default: '00000000-0000-0000-0000-000000000000',
        },

        queryString: {
            type: String,
            default: '',
        },

        target: {
            type: String,
            default: '',
        },

        title: {
            type: String,
            default: '',
        },
        // Link props end

        ariaLabel: {
            type: String,
            default: null,
        },

        ariaLabelledBy: {
            type: String,
            default: null,
        },

        accessibilityRole: {
            type: String,
            default: null,
        },

        ariaHidden: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            templateType: '', // the Sitecore template type
        };
    },

    computed: {
        htmlClass() {
            return this.classes.split(' ');
        },

        renderHref() {
            let buildHref = '';

            if (this.href) {
                buildHref = this.href;

                if (this.linkType === 'internal') {
                    if (this.queryString && !buildHref.includes(this.queryString)) {
                        buildHref += `?${ this.queryString }`;
                    }
                }
            }

            if (this.anchor) {
                buildHref += `#${ this.anchor }`;
            }

            return buildHref;
        },

        renderRel() {
            return this.target === '_blank' ? 'noopener noreferrer' : '';
        },

        renderTargetItemId() {
            if (this.linkType !== 'internal' && this.linkType !== 'media') return '';

            return this.mediaId;
        },

        renderTarget() {
            return this.target;
        },
    },

    methods: {
        onClick() {

        },

        getElementData(key) {
            if (!this.customAttributes[key]) return '';

            return JSON.parse(this.customAttributes[key]);
        },

        hasElementData(key) {
            return this.customAttributes
                && Object.prototype.hasOwnProperty.call(this.customAttributes, key);
        },

        setElementData(key, value) {
            if (typeof value !== 'string') {
                throw new Error('custom attributes value must be a string!');
            }
            this.$set(this.customAttributes, key, value);
        },
    },
};
